export const RadioButton = ({ selected }: { selected: boolean }) => {
    return (
        <div className="w-6 h-6 border-2 border-rose-400 rounded-full flex items-center justify-center">
            {selected && <div className="bg-rose-600 w-3 h-3 rounded-full"></div>}
        </div>
    );
};
